import { authGuard } from '@auth0/auth0-vue';
import { RouteNames } from '@/data/routes';

import dataSecurityRoutes from '@/routes/data-security.routes';
import teamRoutes from '@/routes/team.routes';

import SettingsPage from '@/pages/settings/SettingsPage.vue';
import AccountLayout from '@/components/layouts/AccountLayout.vue';
import { createRoutes } from '@/utils/router-helper';

export default createRoutes({
  path: '/account',
  name: RouteNames.ACCOUNT.INDEX,
  component: AccountLayout,
  beforeEnter: authGuard,
  redirect: { name: RouteNames.ACCOUNT.SETTINGS },
  meta: {
    requiresAuth: true,
    displayNav: true,
    segment: [
      'core',
      'self_serve',
      'extend_runway',
      'mrr_factoring',
      'indiegogo',
      'bnpl',
    ],
  },
  children: [
    {
      path: 'settings',
      name: RouteNames.ACCOUNT.SETTINGS,
      component: SettingsPage,
    },
    ...dataSecurityRoutes,
    ...teamRoutes,
  ],
});
